import React, { Component } from "react";
import axios from "axios";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import { Editor } from "@tinymce/tinymce-react";
import { connect } from "react-redux";

//componentes
import "./cierreRe.css";
import Alert from "../../modal/alert";
import { fetchSedes } from "../../utils/sedesApi";

class CierreTrimestre extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pasoOn: false,
      fecha: moment().format("YYYY-MM-DD"),
      mensajealerta: false,
      tituloMensaje: "",
      cuerpoMensaje: "",
      transferencia: "",
      deposito: "",
      tarjetaV: "",
      tarjetaC: "",
      efectivo: "",
      cheque: "",
      otrosP: "",
      canjes: "",
      total: "",
      tipoReporteCierre: "",
      sede: "",
      sedes: [],
      archivoExcel: null,
      nombreArchivoExcel: "",
    };
  }

  limpiar = () => {
    this.setState({
      pasoOn: false,
      fecha: moment().format("YYYY-MM-DD"),
      mensajealerta: false,
      tituloMensaje: "",
      cuerpoMensaje: "",
      transferencia: "",
      deposito: "",
      tarjetaV: "",
      tarjetaC: "",
      efectivo: "",
      cheque: "",
      otrosP: "",
      canjes: "",
      total: "",
      tipoReporteCierre: "",
      sede: "",
      archivoExcel: null,
      nombreArchivoExcel: "",
    });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  onChange(e) {
    const { name, value } = e.target;
    if (name === "tipoReporteCierre" && value === "5") {
      this.setState({ tipoReporteCierre: "" });
      this.props.history.push("/cuadreEfectivo");
      return;
    }
    if (
      name === "tipoReporteCierre" &&
      value !== "4" &&
      value !== "6"
    ) {
      this.setState({
        [name]: value,
        archivoExcel: null,
        nombreArchivoExcel: "",
      });
      return;
    }
    this.setState({
      [name]: value,
    });
  }

  onChangeArchivo = (e) => {
    const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
    if (!file) {
      this.setState({ archivoExcel: null, nombreArchivoExcel: "" });
      return;
    }
    const nombre = String(file.name || "").toLowerCase();
    const extOk = nombre.endsWith(".xlsx") || nombre.endsWith(".xls");
    if (!extOk) {
      e.target.value = "";
      this.setState({
        archivoExcel: null,
        nombreArchivoExcel: "",
        mensajealerta: true,
        tituloM: "Cuadre Bancario.",
        cuerpoM: "Solo se permiten archivos Excel (.xlsx o .xls), gracias.",
      });
      return;
    }
    this.setState({
      archivoExcel: file,
      nombreArchivoExcel: file.name,
    });
  };

  imprimirCierre = () => {
    if (!this.state.fecha || this.state.fecha.length === 0) {
      this.setState({
        mensajealerta: true,
        tituloM: "Cierre de Facturas.",
        cuerpoM: "Debe seleccionar una fecha, gracias.",
      });
      return;
    }
    if (!this.state.tipoReporteCierre || this.state.tipoReporteCierre.length === 0) {
      this.setState({
        mensajealerta: true,
        tituloM: "Cierre de Facturas.",
        cuerpoM: "Debe seleccionar el tipo de reporte, gracias.",
      });
      return;
    }

    let data = new FormData();
    data.append("fecha", this.state.fecha);
    data.append("sede", this.state.sede);

    if (this.state.tipoReporteCierre === "1") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/informeRecepcion.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (this.state.tipoReporteCierre === "2") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/informeRecepcionMensualAcumulado.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (this.state.tipoReporteCierre === "3") {
      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/informeRecepcionMensualXDia.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
    if (
      this.state.tipoReporteCierre === "4" ||
      this.state.tipoReporteCierre === "6"
    ) {
      const esSencillo = this.state.tipoReporteCierre === "6";
      const tituloCuadre = esSencillo
        ? "Cuadre Bancario Sencillo."
        : "Cuadre Bancario.";
      if (!this.state.sede || String(this.state.sede).length === 0) {
        this.setState({
          mensajealerta: true,
          tituloM: tituloCuadre,
          cuerpoM: "Debe seleccionar la sede antes de imprimir, gracias.",
        });
        return;
      }
      if (!this.state.archivoExcel) {
        this.setState({
          mensajealerta: true,
          tituloM: tituloCuadre,
          cuerpoM:
            "Debe subir el archivo Excel bancario antes de imprimir, gracias.",
        });
        return;
      }
      data.append("archivo", this.state.archivoExcel);
      axios({
        method: "post",
        url: esSencillo
          ? "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteCuadreBancarioSencillo.php"
          : "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reporteCuadreBancario.php",
        responseType: "arraybuffer",
        data: data,
        headers: { "Content-Type": "multipart/form-data" },
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
  };

  imprimirCierreFS = () => {
    if (this.state.fecha.length > 0) {
      let data = new FormData();
      if (this.props.usuario1.nivel === "12")
        data.append("claveUsu", this.props.usuario1.password);
      if (this.props.usuario1.nivel === "1")
        data.append("claveUsu", "FSERVI01");
      data.append("fecha", this.state.fecha);

      axios({
        method: "post",
        url:
          "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/informeRecepcionFS.php",
        responseType: "arraybuffer",
        data: data,
      }).then(function (response) {
        let blob = new Blob([response.data], { type: "application/pdf" });
        var fileURL = URL.createObjectURL(blob);
        window.open(fileURL);
      });
    }
  };

  montoCierre = () => {
    if (this.state.fecha.length > 0) {
      let data = new FormData();
      data.append("fecha", this.state.fecha);
      data.append("boton", "cierreMontos");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/terapias/backend/facturaRe.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          this.setState({
            pasoOn: true,
            transferencia: res.data.variable1,
            deposito: res.data.variable2,
            tarjetaV: res.data.variable3,
            tarjetaC: res.data.variable4,
            efectivo: res.data.variable5,
            cheque: res.data.variable6,
            otrosP: res.data.variable9,
            canjes: res.data.variable8,
            total: res.data.variable7,
          });
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Consulta Diaria de Montos.",
        cuerpoM: "Debe existir una fecha verifique, gracias.",
      });
    }
  };
  valorInicial = () => {
    if (this.props.usuario1.nivel !=='1') {
      this.setState({
        sede:this.props.usuario1.sede
      });
    }
  }
  componentDidMount() {
    this.valorInicial();
    fetchSedes().then((sedes) => this.setState({ sedes }));
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>CIERRE DE FACTURAS TEMPORALES EMITIDAS.</p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
              eliminar={this.state.elimi}
              handleEliminar={this.handleEliminar}
            />
          )}

          <div className="historia-contenidoant">
            <div className="form-groupev col-12">
              <div className="row">
                <div className="cont-personal col-12">
                  {this.props.usuario1.nivel === "1" && (
                    <div className="contenedorcedula1f col-2">
                      <label className="opcion">Sede.</label>

                      <select
                        id="sede"
                        name="sede"
                        value={this.state.sede}
                        onChange={this.onChange.bind(this)}
                      >
                        <option>-Seleccione Sucursal-</option>
                        {this.state.sedes.map((item) => (
                          <option key={item.variable1} value={String(item.variable1)}>
                            {item.variable2}
                          </option>
                        ))}
                        <option value="0">Todas</option>
                      </select>
                    </div>
                  )}
                  <div className="contenedorcedula1f col-3">
                    <input
                      className="form-control"
                      type="date"
                      name="fecha"
                      id="fecha"
                      autoComplete="off"
                      onChange={this.onChange.bind(this)}
                      value={this.state.fecha}
                    />
                  </div>
                  <div className="contenedorcedula1f col-4">
                    <select
                      id="tipoReporteCierre"
                      name="tipoReporteCierre"
                      value={this.state.tipoReporteCierre}
                      onChange={this.onChange.bind(this)}
                    >
                      <option value="">Tipo de Reporte.</option>
                      <option value="1">Por Dia</option>
                      <option value="2">Mensual Acumulado</option>
                      <option value="3">Mensual Diario</option>
                      <option value="4">Cuadre Bancario</option>
                      <option value="6">Cuadre Bancario Sencillo</option>
                      <option value="5">Cuadre Efectivo</option>
                    </select>
                  </div>
                  {(this.state.tipoReporteCierre === "4" ||
                    this.state.tipoReporteCierre === "6") && (
                    <div className="contenedorcedula1f col-3">
                      <label className="opcion">Excel Bancario.</label>
                      <input
                        type="file"
                        accept=".xlsx,.xls"
                        name="archivoExcel"
                        onChange={this.onChangeArchivo}
                      />
                      {this.state.nombreArchivoExcel ? (
                        <small>{this.state.nombreArchivoExcel}</small>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="botones col-12">
                  <div className="acciones">
                    {/* <button
                      className="boton"
                      onClick={this.montoCierre.bind(this)}
                    >
                      Consultar
                    </button> */}
                    {this.props.usuario1.nivel !== "12" && (
                      <button
                        className="boton"
                        onClick={this.imprimirCierre.bind(this)}
                      >
                        Imprimir
                      </button>
                    )}
                    {/* {this.props.usuario1.nivel !== "12" && (
                      <button
                        className="boton"
                        onClick={this.imprimirCierreFS.bind(this)}
                      >
                        Imprimir Cierre Terapias
                      </button>
                    )}
                    {this.props.usuario1.nivel === "12" && (
                      <button
                        className="boton"
                        onClick={this.imprimirCierreFS.bind(this)}
                      >
                        Imprimir Cierre Terapias
                      </button>
                    )} */}
                    <Link to="/">
                      <button className="boton">Salir</button>
                    </Link>
                  </div>
                </div>
              </div>
              {this.state.pasoOn && (
                <div className="cont-listmedix row">
                  <div className="listcxcx col-12">
                    <div className="row">
                      <div className="conteni">{this.state.transferencia}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.deposito}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.tarjetaV}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.tarjetaC}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.efectivo}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.cheque}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.otrosP}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.canjes}</div>
                    </div>
                    <div className="row">
                      <div className="conteni">{this.state.total}</div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    usuario1: state.usuario1,
    token: state.token,
  };
};
export default withRouter(connect(mapStateToProps)(CierreTrimestre));
